import { render, staticRenderFns } from "./BussBulletinList.vue?vue&type=template&id=729e7f58&"
import script from "./BussBulletinList.vue?vue&type=script&lang=js&"
export * from "./BussBulletinList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports